import { createAction } from '@reduxjs/toolkit';
import EcomEngineAPI from 'api/ecom_engine_api';
import { trackError } from 'utils/helpers';

export const fetchVehiclesStarted = createAction(
  'vehicleLink/fetchVehiclesStarted'
);
export const fetchVehiclesSucceeded = createAction(
  'vehicleLink/fetchVehiclesSucceeded'
);
export const fetchVehiclesFailed = createAction(
  'vehicleLink/fetchVehiclesFailed'
);
export const setVehicles = createAction('vehicleLink/setVehicles');

export const fetchVehicles = (params) => (dispatch, getState) => {
  const cacheKeyName = `${params.code}_${params.makeCode}_${params.familyCode}_${params.bodyStyleCode}`;
  const existingVehicles = getState().vehicleLink.vehicles[cacheKeyName];

  if (existingVehicles) {
    return existingVehicles;
  }

  dispatch(fetchVehiclesStarted());

  return EcomEngineAPI.vehicleLink
    .vehicles(params)
    .then((vehicles) => {
      dispatch(fetchVehiclesSucceeded());
      dispatch(setVehicles({ params, vehicles }));
    })
    .catch((error) => {
      trackError(error);
      dispatch(fetchVehiclesFailed(error.message));
    });
};
